import { Capacitor } from '@capacitor/core';

// Añade el token JWT como query param a URLs de /uploads/ para que funcionen en móvil (img src cross-origin)
export const getUploadUrl = (path) => {
  if (!path) return path;
  const token = localStorage.getItem('token');
  if (!token) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}token=${token}`;
};

// Para enlaces de descarga (no para <img>). La app no sabe abrir ficheros: el WebView no muestra PDF y no
// tiene DownloadListener. Capacitor manda a Chrome toda URL de un host distinto al de la app
// (Bridge.launchIntent), así que en la app se usa www.habitapro.net, que nginx sirve igual que habitapro.net.
export const getDownloadUrl = (path) => {
  const url = getUploadUrl(path);
  if (!url || !Capacitor.isNativePlatform() || !url.startsWith('/')) return url;
  return `https://www.habitapro.net${url}`;
};
